import { gentoken } from '.';
import { types as rs, utcnow } from 'earn-ts';
import { IOrderState } from 'src/reducer/order/orderReducer';
import {
  postItemsToOrderThunk,
  postOrderThunk,
} from 'src/reducer/order/orderThunk';
import { AsyncThunkAction } from '@reduxjs/toolkit';

export function submitOrderSets(
  state: IOrderState,
): null | AsyncThunkAction<any, any, any> {
  if (state.dataSelectedMenus.length == 0) return null;

  let alreadyHaveOrder =
    state.session.kind == 'Table' || state.fullOrder != null;
  const items: rs.OrderMenuSet[] = state.dataSelectedMenus.map(item => {
    return { ...item, created: utcnow() };
  });
  if (alreadyHaveOrder) return postItemsToOrderThunk(items);
  else {
    // TODO tbh not done
    const order_id = gentoken();
    let dataOrder: rs.Order = {
      order_id: order_id,
      shop_id: state.shopId,
      menu_items: items,
      // takeout: state.session.kind == 'Takeout',
      deleted_items: [],
      snapshot: null,
    };
    return postOrderThunk(dataOrder);
  }
}
